import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGlobalStore = defineStore('global', () => {
  const userData = ref(null)
  const menuCollapse = ref(false)
  const locale = ref(localStorage.getItem('lang') || 'zh')
  const theme = ref('dark')

  const setUserData = function(data) {
    userData.value = data
  }
  const setMenuCollapse = function(collapse) {
    menuCollapse.value = collapse
  }
  const setLocale = function(lc) {
    locale.value = lc
  }
  const setTheme = function(th) {
    theme.value = th
  }

  return {
    userData,
    menuCollapse,
    setUserData,
    setMenuCollapse,
    locale,
    setLocale,
    theme,
    setTheme
  }
})